import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

import { BrandType } from "../models/Enums";

@Injectable({
  providedIn: "root",
})
export class BrandingService {
  currentBrand: BrandType;

  constructor() {
    this.setBranding();
    this.setWebTitle();
    this.setFavicon();
    this.setCssVariables();
    this.setMaterialTheme();
  }

  private setWebTitle() {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        document.title = environment.brandWebTitleAtlasCopco;
        break;
      case BrandType.Desoutter:
        document.title = environment.brandWebTitleDesoutter;
        break;
    }
  }

  private setFavicon() {
    const favicon = document.querySelector("#appFavicon") as HTMLLinkElement;
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        favicon.setAttribute("href", environment.brandFaviconAtlasCopco);
        break;

      case BrandType.Desoutter:
        favicon.setAttribute("href", environment.brandFaviconDesoutter);
        break;
    }
  }

  private setMaterialTheme() {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        document.body.classList.add("atlas-copco-theme");
        break;

      case BrandType.Desoutter:
        document.body.classList.add("desoutter-theme");
        break;
    }
  }

  private setBranding(): void {
    const domain = window.location.host;
    if (environment.desoutterDomains.some((d) => domain.includes(d))) {
      this.currentBrand = BrandType.Desoutter;
    } else {
      // default is AtlasCopco
      this.currentBrand = BrandType.AtlasCopco;
    }
  }

  private setCssVariables(): void {
    const root = document.querySelector(":root") as HTMLElement;
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        root.style.setProperty("--brand-color", "var(--atlas-copco-blue)");
        break;

      case BrandType.Desoutter:
        root.style.setProperty("--brand-color", "var(--desoutter-red)");
        break;
    }
  }

  public getBrandTitle(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return environment.brandTitleAtlasCopco;
      case BrandType.Desoutter:
        return environment.brandTitleDesoutter;
    }
  }

  /** Product name as known by the customers of the brand. */
  public getProductName(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return "Where Is My Tool";
      case BrandType.Desoutter:
        return "Track My Service";
    }
  }

  public getServAidUrl(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return environment.atlasCopcoServAidUrl;
      case BrandType.Desoutter:
        return environment.desoutterServAidUrl;
    }
  }

  public getBrandLink(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return environment.brandLinkAtlasCopco;
      case BrandType.Desoutter:
        return environment.brandLinkDesoutter;
    }
  }

  public getBrandLogo(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return environment.brandLogoAtlasCopco;
      case BrandType.Desoutter:
        return environment.brandLogoDesoutter;
    }
  }

  public getBrandBanner(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return environment.brandBannerAtlasCopco;
      case BrandType.Desoutter:
        return environment.brandBannerDesoutter;
    }
  }

  public isAtlasCopcoBrand(): boolean {
    return this.currentBrand === BrandType.AtlasCopco;
  }

  public getYoutubeLink(): string {
    switch (this.currentBrand) {
      case BrandType.AtlasCopco:
        return environment.atlasCopcoTrainingYoutubeLink;
      case BrandType.Desoutter:
        return environment.desoutterTrainingYoutubeLink;
    }
  }
}
